import { render, staticRenderFns } from "./PcCategory.vue?vue&type=template&id=efbb55a0&scoped=true&"
import script from "./PcCategory.vue?vue&type=script&lang=js&"
export * from "./PcCategory.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./PcCategory.vue?vue&type=style&index=0&id=efbb55a0&prod&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "efbb55a0",
  null
  ,true
)

export default component.exports